/* RAWAQ — home interactions: arch "enter" on scroll, room reveals, scent finder, waitlist tags, founding member card + membership code (Arabic + English) */
(function(){
  var root=document.querySelector('.rq'); if(!root) return;
  var EN=(root.getAttribute('lang')||document.documentElement.lang||'').indexOf('en')===0;
  root.classList.add('rq-js');
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Enter: the arch grows until you're inside */
  var enter=document.getElementById('enter');
  if(enter){
    var frame=enter.querySelector('.rq-enter__frame'), img=frame&&frame.querySelector('img'), txt=enter.querySelector('.rq-enter__txt');
    if(img){ img.loading='eager'; }
    var ticking=false;
    function draw(){
      ticking=false;
      var r=enter.getBoundingClientRect(), vh=window.innerHeight, total=r.height-vh;
      var p=total>0?Math.min(1,Math.max(0,-r.top/total)):1;
      if(reduce) p=1;
      var w=frame.clientWidth, h=frame.clientHeight;
      var aw=Math.min(w*0.62, h*0.52*0.8);
      var side=(w-aw)/2*(1-p), top=h*0.2*(1-p), bottom=h*0.08*(1-p);
      var rad=((w-2*side)/2)*(1-p);
      frame.style.clipPath='inset('+top+'px '+side+'px '+bottom+'px '+side+'px round '+rad+'px '+rad+'px 0 0)';
      if(img) img.style.transform='scale('+(1.18-0.18*p)+')';
      if(txt){var o=Math.min(1,Math.max(0,(p-0.55)/0.3)); txt.style.opacity=o; txt.style.transform='translateY('+(20*(1-o))+'px)';}
    }
    function onScroll(){ if(!ticking){ticking=true; requestAnimationFrame(draw);} }
    window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll); draw();
  }

  /* 2) Rooms reveal through an arch as they come into view */
  var items=document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window && !reduce){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:0.25});
    items.forEach(function(el){io.observe(el);});
  } else items.forEach(function(el){el.classList.add('is-in');});

  /* 3) Waitlist form + scent finder */
  var f=document.getElementById('dx-form'); if(!f) return;
  var chks=[].slice.call(f.querySelectorAll('.dx-chk')), n=document.getElementById('dx-n'), pk=document.getElementById('dx-picked');
  function upd(){var a=[];chks.forEach(function(c){if(c.checked)a.push(c.dataset.name)});if(n)n.textContent=a.length;if(pk)pk.textContent=a.length?a.join(EN?', ':'، '):(EN?'None yet':'لسه مافيش');}
  chks.forEach(function(c){c.addEventListener('change',upd)}); upd();

  var quiz=document.getElementById('rq-quiz'), ans={};
  if(quiz){
    var qs=[].slice.call(quiz.querySelectorAll('.rq-q')), bar=document.getElementById('rq-quiz-bar'), res=document.getElementById('rq-result'), back=document.getElementById('rq-back'), best=null, cur=0;
    function show(i){cur=i; qs.forEach(function(q,k){q.hidden=(k!==i);}); res.hidden=(i<qs.length); if(back) back.hidden=(i===0); if(bar) bar.style.width=(Math.min(i,qs.length)/qs.length*100)+'%';}
    if(back) back.addEventListener('click',function(){ if(cur>0) show(cur-1); });
    function score(c){
      var s=0; if(c.dataset.room===ans.room) s+=3; if(c.dataset.mood===ans.mood) s+=2;
      if(ans.time==='morning'&&c.dataset.mood==='fresh') s+=1;
      if(ans.time==='laundry'&&c.dataset.room==='laundry') s+=1;
      if(ans.time==='night'&&(c.dataset.mood==='warm'||c.dataset.mood==='floral')) s+=1;
      return s;
    }
    function result(){
      var ranked=chks.slice().sort(function(a,b){return score(b)-score(a);});
      best=ranked[0];
      var im=document.getElementById('rq-r-img'), artBox=res.querySelector('.rq-result__art');
      if(best.dataset.img){im.src=best.dataset.img; im.alt=''; artBox.classList.remove('is-air');} else {im.removeAttribute('src'); artBox.classList.add('is-air');}
      document.getElementById('rq-r-cat').textContent=best.dataset.cat;
      document.getElementById('rq-r-name').textContent=best.dataset.name;
      document.getElementById('rq-r-note').textContent=best.dataset.note;
      document.getElementById('rq-r-alt').textContent=ranked.slice(1,3).map(function(c){return c.dataset.name+' ('+c.dataset.cat+')';}).join(' · ');
      show(qs.length);
    }
    qs.forEach(function(q,i){
      q.querySelectorAll('.rq-opt').forEach(function(b){
        b.addEventListener('click',function(){
          ans[q.dataset.q]=b.dataset.v;
          q.querySelectorAll('.rq-opt').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
          setTimeout(function(){ if(i<qs.length-1) show(i+1); else result(); }, reduce?0:220);
        });
      });
    });
    document.getElementById('rq-r-go').addEventListener('click',function(){ if(best){best.checked=true; upd();} });
    document.getElementById('rq-r-again').addEventListener('click',function(){ ans={}; quiz.querySelectorAll('.rq-opt').forEach(function(x){x.removeAttribute('aria-pressed');}); show(0); });
    show(0);
  }

  f.addEventListener('submit',function(){
    var t=['waitlist','founding-member']; chks.forEach(function(c){if(c.checked)t.push(c.value)});
    if(ans.room) t.push('q-room-'+ans.room); if(ans.mood) t.push('q-mood-'+ans.mood); if(ans.time) t.push('q-time-'+ans.time);
    if(EN) t.push('lang-en');
    var ar=document.getElementById('dx-area'); if(ar&&ar.value)t.push(ar.value);
    var ct=document.getElementById('dx-city'); if(ct&&ct.value.trim())t.push('city-'+ct.value.trim().replace(/[,،]/g,' ').slice(0,40));
    var w=document.getElementById('dx-wa'); if(w&&w.value){var d=w.value.replace(/\D/g,'');if(d.indexOf('20')===0)d=d.slice(2);if(d.charAt(0)!=='0')d='0'+d;t.push('wa-'+d);}
    var code=''; try{var A='ABCDEFGHJKMNPQRSTUVWXYZ23456789',r=new Uint8Array(4); (window.crypto||window.msCrypto).getRandomValues(r); var d0=new Date();
      code='F-'+String(d0.getFullYear()).slice(2)+('0'+(d0.getMonth()+1)).slice(-2)+'-'+[].map.call(r,function(v){return A.charAt(v%A.length);}).join('');}catch(e){}
    if(code) t.push('member-'+code);
    var h=document.getElementById('dx-tags'); if(h)h.value=t.join(', ');
    try{var nm=f.querySelector('[name="contact[first_name]"]'); var pick=chks.filter(function(c){return c.checked;}).map(function(c){return c.dataset.name;});
      sessionStorage.setItem('rq_member',JSON.stringify({name:nm?nm.value.trim().slice(0,28):'',scent:pick[0]||'',code:code,en:EN}));}catch(e){}
  });
  function cityOptional(){var cs=document.getElementById('dx-city-sel'); if(cs&&cs.tagName==='SELECT') cs.required=false;}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setTimeout(cityOptional,0);}); else setTimeout(cityOptional,0);
  var gv=document.getElementById('dx-area'); if(gv) gv.addEventListener('change',function(){setTimeout(cityOptional,0);});

  /* 4) Founding member card (after a successful sign-up) — an invitation on ivory paper (Card, 22 Oct):
        double hairline frame, membership number at the top, the arch with the wordmark and a rising sun, name as the focus, signature at the foot. */
  var card=document.getElementById('rq-card');
  if(card && f.querySelector('.dx-done')){ try{ buildCard(card); }catch(e){} }
  function buildCard(box){
    var m={}; try{m=JSON.parse(sessionStorage.getItem('rq_member')||'{}');}catch(e){}
    var W=1080,H=1350, G='#183D2C', IV='#FFF9F0', TC='#BB6748', MU='#5B5F55', SUN='#FFD23F';
    var month=''; try{month=new Intl.DateTimeFormat(EN?'en-GB':'ar-EG',{month:'long',year:'numeric'}).format(new Date());}catch(e){}
    var logoSrc=((document.querySelector('.rq-nav__logo img')||{}).src||'').replace('rawaq-wordmark-cream','rawaq-wordmark');
    function draw(withLogo, logo){
      var c=document.createElement('canvas'); c.width=W; c.height=H; var x=c.getContext('2d');
      x.fillStyle=IV; x.fillRect(0,0,W,H);
      for(var i=0;i<9000;i++){ x.fillStyle='rgba(24,61,44,'+(Math.random()*0.05).toFixed(3)+')'; x.fillRect(Math.random()*W,Math.random()*H,1.4,1.4); }
      x.strokeStyle='rgba(24,61,44,.38)'; x.lineWidth=2; x.strokeRect(44,44,W-88,H-88);
      x.strokeStyle='rgba(24,61,44,.16)'; x.lineWidth=1; x.strokeRect(60,60,W-120,H-120);
      x.textAlign='center'; x.textBaseline='alphabetic';
      if(m.code){ x.direction='ltr'; x.fillStyle=G; x.font='500 24px "Readex Pro", sans-serif'; x.fillText('Nº  '+m.code,540,140); }
      x.strokeStyle=G; x.lineWidth=2; x.beginPath(); x.moveTo(340,700); x.lineTo(340,470); x.arc(540,470,200,Math.PI,0); x.lineTo(740,700); x.stroke();
      x.strokeStyle='rgba(24,61,44,.3)'; x.lineWidth=1; x.beginPath(); x.moveTo(250,700); x.lineTo(830,700); x.stroke();
      x.fillStyle=SUN; x.beginPath(); x.arc(540,700,52,Math.PI,0); x.closePath(); x.fill();
      x.direction=EN?'ltr':'rtl';
      if(withLogo&&logo){ var lw=250, lh=lw*(logo.naturalHeight||57)/(logo.naturalWidth||96); x.drawImage(logo,540-lw/2,450-lh/2,lw,lh); }
      else { x.fillStyle=G; x.font='700 92px "El Messiri", serif'; x.fillText(EN?'RAWAQ':'رَواق',540,480); }
      x.direction='ltr'; x.fillStyle=G; x.font='500 24px "Readex Pro", sans-serif'; x.fillText('F O U N D I N G   M E M B E R',540,790);
      x.direction=EN?'ltr':'rtl';
      var nm=m.name||'', title=nm||(EN?'Founding Member':'عضو مؤسس');
      var fs=nm?88:76; x.font='500 '+fs+'px "El Messiri", serif'; while(x.measureText(title).width>760&&fs>44){fs-=4; x.font='500 '+fs+'px "El Messiri", serif';}
      x.fillStyle=G; x.fillText(title,540,890);
      x.fillStyle=MU; x.font='300 32px "Readex Pro", sans-serif'; x.fillText(EN?'One of the first 1,000 founding members':'من أول ١٠٠٠ عضو مؤسس في رَواق',540,962);
      var y=1030;
      if(m.scent){ x.fillStyle=G; x.font='500 32px "Readex Pro", sans-serif'; x.fillText((EN?'Your scent: ':'ريحتكم: ')+m.scent,540,y); y+=52; }
      if(month){ x.fillStyle=MU; x.font='300 26px "Readex Pro", sans-serif'; x.fillText(month,540,y); }
      x.fillStyle=TC;
      if(EN){ x.font='italic 500 48px "El Messiri", serif'; x.fillText('Home, refined.',540,1185); } else { x.font='700 56px "Aref Ruqaa", "El Messiri", serif'; x.fillText('رَواق… والبيت راق',540,1190); }
      x.direction='ltr'; x.fillStyle=MU; x.font='400 24px "Readex Pro", sans-serif'; x.fillText('rawaqegypt.com',540,1250);
      return c;
    }
    function finish(c){
      var url; try{ url=c.toDataURL('image/png'); }catch(e){ c=draw(false); url=c.toDataURL('image/png'); }
      var img=document.getElementById('rq-card-img'); img.src=url; box.hidden=false;
      var cc=document.getElementById('rq-card-code'); if(cc&&m.code){ cc.textContent=(EN?'Your membership code: ':'كود عضويتكم: ')+m.code; cc.hidden=false; }
      var dl=document.getElementById('rq-card-dl'); dl.href=url;
      var sh=document.getElementById('rq-card-share');
      var txt=EN?'I just became a RAWAQ founding member. Join the waitlist: https://rawaqegypt.com/en':'بقيت عضو مؤسس في رَواق. سجّلوا إنتو كمان: https://rawaqegypt.com';
      sh.addEventListener('click',function(){
        c.toBlob(function(b){
          var file=b&&window.File?new File([b],'rawaq-founding-member.png',{type:'image/png'}):null;
          if(file&&navigator.canShare&&navigator.canShare({files:[file]})){ navigator.share({files:[file],text:txt}).catch(function(){}); }
          else { window.open('https://wa.me/?text='+encodeURIComponent(txt),'_blank','noopener'); }
        });
      });
    }
    var ready=(document.fonts&&document.fonts.load)?Promise.all(['700 92px "El Messiri"','500 88px "El Messiri"','300 32px "Readex Pro"','400 24px "Readex Pro"','500 24px "Readex Pro"','700 56px "Aref Ruqaa"'].map(function(f){return document.fonts.load(f);})).catch(function(){}):Promise.resolve();
    ready.then(function(){
      if(!logoSrc){ finish(draw(false)); return; }
      var lo=new Image(); lo.crossOrigin='anonymous';
      lo.onload=function(){ finish(draw(true,lo)); }; lo.onerror=function(){ finish(draw(false)); };
      lo.src=logoSrc+(logoSrc.indexOf('?')>-1?'&':'?')+'cors=1';
    });
  }
  if(f.querySelector('.dx-done,.dx-err'))document.getElementById('join').scrollIntoView();
})();
